import { lazy } from 'react';
import type { Routes } from '@/@types/routes';
import { DASHBOARD_PREFIX_PATH, DASHBOARD_ROUTES } from '@/constants/route.constant';

const dashboardRoutes: Routes = [
  {
    key: 'dashboard.analytic',
    path: `${DASHBOARD_PREFIX_PATH}/${DASHBOARD_ROUTES.ANALYTIC}`,
    component: lazy(() => import('@/views/dashboard/AnalyticDashboard')),
    authority: ['SUPERADMIN'],
    meta: {
      pageContainerType: 'contained',
    },
  },
];

export default dashboardRoutes;
